<mat-progress-spinner
  class="example-margin"
  color="primary"
  mode="indeterminate"
>
</mat-progress-spinner>
